import React from 'react';
import { Rect } from 'react-konva';
import {
  isMobilePhone,
} from '../../../library/calc';

export default ({ fn,
    n,
    g,
    pid,
    left,
    top,
    focus,
    stopStageClickPropagation,
    p,
    nn,
    strokeWidth,
    bubbleBodyHeight,
    bubbleBodyWidth,
    yCoord4Bubble,
    leftBubble,
    cursorBecomesMove,
    cursorBecomesPointer,
  }) => {

  left += leftBubble;
  top += yCoord4Bubble;

  return <Rect
    x={left}
    y={top}
    width={bubbleBodyWidth}
    height={bubbleBodyHeight}
    cursor="pointer"
    fill="white"
    stroke="gray"
    strokeWidth={strokeWidth}
    cornerRadius={1.5}

    onTouchStart={()=>{
      stopStageClickPropagation({fromWhere: 'matches bubble A'});
    }}

    onClick={()=>{
      if(isMobilePhone() ) return;
      stopStageClickPropagation({fromWhere: 'matches bubble B'});
    }}

    onMouseenter={()=>{
      cursorBecomesPointer();
    }}
    onMouseleave={()=>{
      cursorBecomesMove();
    }}
  />;
};

